import $ from 'jquery'
import { actionSelect } from './selector'
import {Core} from "./core.js";

$(document).ready(function () {
  if (! Core.isAdmin()) {
    $( 'body' ).on('DOMSubtreeModified', initKoalaBooxForm )
  }
})

function initKoalaBooxForm () {
  $('form._form[class*=_form_]:not(.form-stylised)').each(updateStyle)
}

function updateStyle (index, form) {
  let $form = $(form)

  $form.addClass('form-stylised')

  updateSelectStyle()

  $form.parent().find('style').remove();
}

function updateSelectStyle () {
  // Generate fake select
  $('.mktoFieldWrap select').each(actionSelect)
}
